import { LocalLookupService } from "@ofqual/portal-core/core/dataAccess";
import { ApqService } from "./ApqService";
import { AwardingOrgService } from "./AwardingOrgService";
import { AwardingOrgSearchService } from "./AwardingOrgSearchService";
import {
  API_HOST_ORGS,
  API_HOST_SEARCH,
  API_HOST_APQ,
  API_HOST_USERS,
  API_HOST_REFDATA,
  API_HOST_GUIDANCE
} from "../config";
import { UserService } from "./UserService";
import apqStatuses from "./json/apqStatuses.json";
import { ApqSourceTypeService } from "./ApqSourceTypeService";
import { ApprenticeshipSearchService } from "./ApprenticeshipSearchService";
import { ApprenticeshipStandardService } from "./ApprenticeshipStandardService";
import { QueryClassificationService } from "./QueryClassificationService";
import { ApqQueryFlagService } from "./ApqQueryFlagService";
import { ApqEngagementActivityService } from "./ApqEngagementActivityService";
import { ApqTypeService } from "./ApqTypeService";
import { ApqPriorityService } from "./ApqPriorityService";
import { cachingService } from "@ofqual/portal-core/core/dataAccess";
import { GuidanceService } from "./GuidanceService"
import { ApqFitForPurposeService } from "./ApqFitForPurposeService";
import { ApqAreaForImprovementService } from "./ApqAreaForImprovementService";
import {ApqStakeholderTypeService} from "./ApqStakeholderTypeService";

export const apqService = new ApqService(API_HOST_APQ);
export const aoService = new AwardingOrgService(API_HOST_ORGS);
// export const epaoTypeLookupService = new LocalLookupService(epaoTypeData);
export const aoServiceSearch = new AwardingOrgSearchService(API_HOST_SEARCH);
export const usersService = new UserService(API_HOST_USERS);
export const apqStatusService = new LocalLookupService(apqStatuses);

export const apqSourceTypeService = new ApqSourceTypeService(API_HOST_REFDATA);
export const cachedApqSourceTypeService = cachingService(apqSourceTypeService);

export const apprenticeshipSearchService = new ApprenticeshipSearchService(API_HOST_REFDATA);

export const apprenticeshipStandardService = new ApprenticeshipStandardService(API_HOST_REFDATA);
export const cachedApprenticeshipStandardService = cachingService(apprenticeshipStandardService);

export const apqQueryClassificationService = new QueryClassificationService(API_HOST_REFDATA);
export const cachedQueryClassificationService = cachingService(apqQueryClassificationService);

export const apqQueryFlagService = new ApqQueryFlagService(API_HOST_REFDATA);
export const cachedQueryFlagService = cachingService(apqQueryFlagService);

export const apqEngagementService = new ApqEngagementActivityService(API_HOST_REFDATA);
export const cachedApqEngagementActivityService = cachingService(apqEngagementService);

export const apqTypeService = new ApqTypeService(API_HOST_REFDATA);
export const cachedApqTypeService = cachingService(apqTypeService);

export const apqQueryPriorityService = new ApqPriorityService(API_HOST_REFDATA);
export const cachedApqPriorityService = cachingService(apqQueryPriorityService);

export const apqFitForPurposeService = new ApqFitForPurposeService(API_HOST_REFDATA);
export const cachedApqFitForPurposeService = cachingService(apqFitForPurposeService);

export const apqAreaForImprovementService = new ApqAreaForImprovementService(API_HOST_REFDATA);
export const cachedApqAreaForImprovementService = cachingService(apqAreaForImprovementService);

export const ApqStakeholderService = new ApqStakeholderTypeService(API_HOST_REFDATA);
export const cachedApqStakeholderService = cachingService(ApqStakeholderService); 

export const guidanceService = new GuidanceService(API_HOST_GUIDANCE);
